import React, { useRef } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { MdContentCopy } from "react-icons/md";
import { Toast } from 'primereact/toast';



const CodeViewer = ({ data }) => {
    const toast = useRef(null);

    const handleCopy = () => {
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'Code copied to clipboard' });
    }
    return (
        <>
            <div title='Copy to clipboard' style={{ backgroundColor: "black", color: "white", borderRadius: "10px", padding: "20px", position: "relative" }}>
                <Toast ref={toast} />
                <CopyToClipboard text={data} onCopy={handleCopy}>
                    <MdContentCopy style={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer', color: "white" }} />
                </CopyToClipboard>
                <pre >{data}</pre>
            </div>


        </>
    )
}

export default CodeViewer